// export const API_BASE_URL = "http://localhost:8080";
// export const API_BASE_URL = "http://192.168.8.79:8080";
export const API_BASE_URL = "http://85.159.27.114";
export const CLIENT_BASE_URL = "http://localhost:3000";
// export const CLIENT_BASE_URL = "https://brainbrew.kz";